<template>
  <div v-if="loading.Data" class="d-flex flex-column h-100">
    <spinner-loading ></spinner-loading>
  </div>
  <div v-else  class="d-flex flex-column h-100">
    <div class="h-100 content-body-card">
      <div class="h-100 d-flex justify-content-center body-multi-card">
        <div
          class="w-100 d-flex align-items-center"
          v-for="(item, index) in renderData.data"
          :key="item.title + index"
          :class="index > 0 && 'multi-line-break'"
        >
          <div class="h-100 w-100">
            <div> 
              <div class="multi-overall-card-title">
                {{ item.title }}
              </div>
            </div>
            <div class="multi-overall-card-content-value">
              <div  v-if="item.value">
                <div class="multi-overall-card-value">
                  {{ formatter.format(item.value) }}
                </div>
                <div class="summary-dashboard-unit">
                  {{ item.unit }}
                </div>
              </div>
              <div v-else class="h-100" >
                <card-no-item :text-no-img="'Item Not Found'" :height="100" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import {
  reactive,
  onMounted,
} from "@vue/composition-api";
import { formatter } from "@/utils/scripts/format-currency";
import { dynamicTableModel } from "@/models/data-management/dynamic-table";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";


export default {
  components: {
    CardNoItem,
  },
  props: {
    configCard: Object,
    dataBi: { type: Array, default: () => [] },
    keyid: Object,
    dynamicTableConfig: Object,
    BrandAppDetail: Object,
  },
  setup(props) {

    const {
      openDefaultErrorModal,
    } = useValidationModal();

    const { fetchQueryDataModel } = dynamicTableModel();

    const loading = reactive({
      Data: false,
    });

    const renderData = reactive({
      card_name: "",
      keyid: "",
      tooltip: "",
      fields: [],
      data : []
    })

    const fetchSummaryDetail = () => {
      loading.Data = true;

      const payload = {
        QueryData_Key: props.keyid.query_data_key,
        Query_Data_Key_Type: props.keyid.query_data_key_type,
        Display_Key: props.dynamicTableConfig.displayKey,
        Display_ChartId: props.keyid.display_chartid,
      };

      fetchQueryDataModel.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataModel)
        .then((response) => {
          const respData = response.data.payload.find((o) => o.keyid == props.keyid.query_data_key);
          renderData.card_name = respData.card_name;
          renderData.keyid = respData.keyid;
          renderData.tooltip = respData.tooltip;
          renderData.fields = respData.fields;
          renderData.data = respData.data;
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    onMounted(() => {
      fetchSummaryDetail();
    });

    return {
      loading,
      formatter,
      renderData,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/data-management/summary-dashboard.css";

.multi-overall-card {
  border-radius: 1.428rem;
}

.no-item-container {
  height: 100% !important;
}

.multi-overall-card-title {
  padding: 1rem !important;
  text-align: left;
  font-size: 26px;
  color: rgb(0, 0, 0);
}

.multi-overall-card-content-value {
  height: 50%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.multi-overall-card-value {
  text-align: center;
  font-size: 45px;
  font-weight: bold;
  color: #000000 !important;
}
</style>
